import { AutocompleteItem } from '@akelius-con/react-ui-kit-components';

const getSelectedApartment = (apartments: AutocompleteItem[], apartmentId: string | null) => {
    if (!apartmentId) return null;
    const apartmentOption = apartments.find((apartment: AutocompleteItem) => apartment.value === apartmentId);
    return apartmentOption || { value: '', label: '' };
};

export default getSelectedApartment;
